import graphql from 'babel-plugin-relay/macro';
import LoadingState from 'components/organization/loadingState';
import PropType from 'prop-types';
import React from 'react';
import { QueryRenderer } from 'react-relay';
import { hasElevatedRights } from 'utils/elevatedRights';

import { withGqlClient } from '../gqlClient';
import SignedInViewer from './signedInViewer';

export { UserContext, withUser } from './signedInViewer';

const meQuery = graphql`
  query privateRouteUserQuery {
    me {
      isSuperuser
      isDeveloper
      ... on User {
        ...signedInViewer_user
      }
    }
  }
`;

const orgsQuery = graphql`
  query privateRouteOrgsQuery {
    organizations {
      ... on OrganizationsConnection {
        ...signedInViewer_superUserOrgs
      }
    }
  }
`;

export class PrivateRoute extends React.Component {
  static propTypes = {
    component: PropType.func.isRequired,
    environment: PropType.object.isRequired
  };

  render() {
    const { component, environment, ...rest } = this.props;
    return (
      <QueryRenderer
        environment={environment}
        query={meQuery}
        render={({ error: userError, props: userProps }) => {
          if (userError) return <div>error!</div>;
          if (!userProps) return <LoadingState fullHeight />;
          if (!hasElevatedRights(userProps.me)) {
            return (
              <SignedInViewer
                component={component}
                superUserOrgs={null}
                user={userProps.me}
                {...rest}
              />
            );
          }
          return (
            <QueryRenderer
              environment={environment}
              query={orgsQuery}
              render={({ error: orgError, props: orgProps }) => {
                if (orgError) return <div>error!</div>;
                if (!orgProps) return <LoadingState fullHeight />;
                return (
                  <SignedInViewer
                    component={component}
                    superUserOrgs={orgProps.organizations}
                    user={userProps.me}
                    {...rest}
                  />
                );
              }}
              variables={{}}
            />
          );
        }}
        variables={{}}
      />
    );
  }
}

export default withGqlClient(PrivateRoute);
